import { gql } from '@apollo/client';
const REVERT_ORDER_SPECIFICATION_PRODUCTION_APPROVAL = gql `
  mutation RevertOrderSpecificationProductionApproval($orderId: ID!, $specificationId: ID!) {
    revertOrderSpecificationProductionApproval(
      orderId: $orderId
      specificationId: $specificationId
    ) {
      specification {
        id
      }
      productionApproved
      productionStartDate
      virtualProductionEndDate
      sumOfModelQuantities
      totalProductionTimeMinutes
      priority
      manufacturer {
        id
        shortName
        fullName
        employeesCount
        picture
        nonWorkingDays {
          id
          startDate
          endDate
        }
      }
      modelsCount
      suppliersCount
      manufacturerOccupiedDates
    }
  }
`;
export default REVERT_ORDER_SPECIFICATION_PRODUCTION_APPROVAL;
